import './tinyMCE.css';

import { Editor } from '@tinymce/tinymce-react';
import { useMemo, useRef } from 'react';
import { Editor as EditorType, RawEditorSettings } from 'tinymce';

import { useLoading } from '../../hooks';
import { getTinyMceConfig } from './utils';

type ActionName = 'exportpdf' | 'inserirVariavel' | 'copyContent';

export type TinyMCEConfig = RawEditorSettings & {
  selector?: undefined;
  target?: undefined;
};

export type TinyMCEAction = {
  name: ActionName;
  execute?: (currentTemplate?: string) => Promise<any> | undefined;
};

export type TinyMCEProps = {
  value: string;
  actions?: TinyMCEAction[];
  disabled?: boolean;
  onChange?: (content: string) => void;
  editorId?: string;
};

export const TinyMCE = (props: TinyMCEProps) => {
  const [running, setRunning] = useLoading();

  const {
    value,
    onChange,
    actions = [],
    disabled = false,
    editorId = 'modelo-dados-editor'
  } = props;

  const config = useMemo(() => {
    return getTinyMceConfig(
      actions.map(action => ({
        ...action,
        execute:
          action.execute &&
          ((...args: any[]) =>
            setRunning(action.execute?.(...args) || Promise.resolve()))
      }))
    );
  }, [actions]);

  const ref = useRef<EditorType | null>(null);

  const handleEditorChange = () => {
    if (ref.current) {
      onChange?.(ref.current.getContent());
    }
  };

  return (
    <div
      className={`editor-tinymce-div${running ? ' tox-running-action' : ''}`}
    >
      <Editor
        id={editorId}
        value={value}
        disabled={disabled}
        init={config}
        onEditorChange={handleEditorChange}
        onInit={(_, editor) => (ref.current = editor)}
      />
    </div>
  );
};
